import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ProductReveal } from './components/ProductReveal';
import { BenefitsSection } from './components/BenefitsSection';
import { TargetAudience } from './components/TargetAudience';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-50 font-sans selection:bg-teal-500/30" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <ProductReveal data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <TargetAudience data-id="element-6" />
      <BonusesSection data-id="element-7" />
      <PricingSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />

      {/* Footer minimalista */}
      <footer className="bg-slate-950 py-8 text-center border-t border-slate-900" data-id="element-10">
        <p className="text-slate-500 text-sm" data-id="element-11">
          © {new Date().getFullYear()} Kit Ortopedista Pro. Todos los derechos
          reservados.
        </p>
      </footer>

      <SocialProofPopup data-id="element-12" />
    </div>;
}